import { FC } from 'react'
import cn from 'classnames'

import styles from './gradient-box.module.css'

const GradientBox: FC<{ className?: string, backgroundColor?: string, children?: React.ReactNode }> = ({ children, className = "", backgroundColor = '#000' }) => (
   <div className={cn(styles.gradientBox, className)}>
      <div style={{ backgroundColor }}>{children}</div>
   </div>
)

export default GradientBox;
